import { AfterViewInit, Component, OnInit } from '@angular/core';
import { IPlatformToolHandler } from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';
import { FieldDefinition } from '@shared/models/field-definition';
import { PlatformQueryResponse } from '@shared/models/platform-query/platform-query';
import { CardHolder, CardModel, IPlatformToolCard, MagicLinkModel } from '@shared/models/platform-tool-models';

@Component({
    standalone: false,
    selector: 'app-select-field-notebook-card',
  templateUrl: './select-field-notebook-card.component.html',
  styleUrls: ['./select-field-notebook-card.component.scss']
})
export class SelectFieldNotebookCardComponent implements OnInit, AfterViewInit, IPlatformToolCard {

  constructor() { }
  handler: IPlatformToolHandler;
  magicLinkModel: MagicLinkModel;
  invalidateSubject: InvalidateSubject;
  cardHolder: CardHolder;
  card: CardModel;
  queryResponse: PlatformQueryResponse;

  fields: FieldDefinition[];

  onLoad() {
    this.fields = this.card.fieldValues["Fields"];
    
  }
  ngAfterViewInit(): void {
    throw new Error('Method not implemented.');
  }

  ngOnInit(): void {
  }

  drag(ev, field) {
    ev.dataTransfer.setData("dragItem", field.header);
  }
}
